import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import { debounce } from 'flarum/common/utils/throttleDebounce';
import app from 'flarum/forum/app';
import MobileTabItemsRegistryForum from '../data/MobileTabItemsRegistryForum';
import MobileTabItem from './MobileTabItem';
export default class MobileTab extends Component {
  constructor() {
    var _app$forum$attribute;
    super(...arguments);
    _defineProperty(this, "lastScrollTop", 0);
    _defineProperty(this, "scrollThreshold", (_app$forum$attribute = app.forum.attribute('acplMobileTabScrollThreshold')) != null ? _app$forum$attribute : 80);
    _defineProperty(this, "isHidden", false);
    _defineProperty(this, "show", () => {
      if (!this.isHidden) return;
      this.element.classList.remove('MobileTab--hidden');
      this.element.removeAttribute('inert');
      this.isHidden = false;
    });
    _defineProperty(this, "hide", () => {
      if (this.isHidden) return;
      this.element.classList.add('MobileTab--hidden');
      this.element.setAttribute('inert', '');
      this.isHidden = true;
    });
    _defineProperty(this, "handleScroll", event => {
      const scrollTop = window.scrollY;
      this.resetScrollReference();
      if (scrollTop <= 0) {
        this.show();
        this.lastScrollTop = 0;
        return;
      }

      // Ignore small movements
      if (Math.abs(scrollTop - this.lastScrollTop) < this.scrollThreshold) {
        return;
      }
      if (scrollTop > this.lastScrollTop) {
        this.hide();
      } else {
        this.show();
      }
      this.lastScrollTop = scrollTop;
    });
    /**
     * Reset the reference point when scrolling stops.
     * This prevents small, accumulated deltas from triggering visibility changes immediately after the user pauses and resumes scrolling.
     */
    _defineProperty(this, "resetScrollReference", debounce(150, () => {
      this.lastScrollTop = window.scrollY;
    }));
  }
  oncreate(vnode) {
    var _app$forum$attribute2;
    super.oncreate(vnode);
    if ((_app$forum$attribute2 = app.forum.attribute('acplMobileTabHideOnScroll')) != null ? _app$forum$attribute2 : true) {
      addEventListener('scroll', this.handleScroll, {
        passive: true
      });
    }
  }
  onremove(vnode) {
    super.onremove(vnode);
    removeEventListener('scroll', this.handleScroll);
  }
  view(vnode) {
    return m("nav", {
      className: "MobileTab"
    }, m("ul", {
      className: "MobileTab-items"
    }, this.items().toArray().filter(_ref => {
      let canView = _ref.canView;
      return typeof canView === 'function' ? canView() : canView != null ? canView : true;
    }).map(item => m("li", {
      key: item.itemName
    }, item.forumComponent ? m(item.forumComponent, {
      definition: item
    }) : m(MobileTabItem, {
      href: typeof item.href === 'function' ? item.href() : item.href,
      icon: item.icon,
      target: item.isNewTab ? '_blank' : undefined,
      external: item.isInternal === undefined ? false : !item.isInternal
    }, item.label)))));
  }
  items() {
    const registeredItems = new MobileTabItemsRegistryForum().items();
    const settings = app.forum.attribute('acplMobileTabItems');
    const items = new ItemList();
    settings.forEach(item => {
      if (registeredItems.has(item)) {
        items.add(item, registeredItems.get(item));
      }
    });
    return items;
  }
}
flarum.reg.add('acpl-mobile-tab', 'forum/components/MobileTab', MobileTab);